// store.js
import Vue from 'vue';
import Vuex from 'vuex';

// 确保在创建store之前注册Vuex
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 图标背景色配置
    iconBackgroundConfig: {
      'task': {
        type: 'solid',
        color: '#2254F4'
      },
      'taskana': {
        type: 'gradient',
        colors: ['#24CFF7', '#0A83F9'],
        direction: 'to top'
      },
      'project': {
        type: 'solid',
        color: '#00A714'
      },
      'projectana': {
        type: 'gradient',
        colors: ['#00D6C2', '#00E19D'],
        direction: 'to top'
      },
      'plan': {
        type: 'solid',
        color: '#EFC62E'
      },
      'oa': {
        type: 'gradient',
        colors: ['#EC2F22', '#E90D1B'],
        direction: 'to top'
      },
      'okr': {
        type: 'solid',
        color: '#E3007E'
      },
      'replay': {
        type: 'solid',
        color: '#01AFFD'
      },
      'card': {
        type: 'solid',
        color: '#FBE1FF'
      },
      'businesscard': {
        type: 'solid',
        color: '#CA6EE0'
      },
      'xy': {
        type: 'gradient',
        colors: ['#0E2F5B', '#315B56'],
        direction: 'to top'
      }
    },
    
    historyMenu: []
  },
  mutations: {
    // 添加历史路由
    ADD_HISTORY_MENU(state, route) {
      // 检查是否已存在相同的路由（基于key、name、type的组合判断）
      const existingIndex = state.historyMenu.findIndex(item => 
        item.key === route.key && 
        item.name === route.name && 
        item.type === route.type
      );
      
      if (existingIndex !== -1) {
        // 如果存在，更新时间和数据并移到最前面
        const existingRoute = state.historyMenu.splice(existingIndex, 1)[0];
        existingRoute.createTime = Date.now();
        existingRoute.value = route.value; // 更新数据
        state.historyMenu.unshift(existingRoute);
      } else {
        // 如果不存在，添加新路由
        const newRoute = {
          id: Date.now(), // 简单的ID生成
          name: route.name,
          key: route.key,
          value: route.value,
          type: route.type || 'list',
          createTime: Date.now()
        };
        state.historyMenu.unshift(newRoute);
        
        // 限制历史记录数量（最多保存30个）
        if (state.historyMenu.length > 30) {
          state.historyMenu = state.historyMenu.slice(0, 30);
        }
      }
    },
    
    // 删除历史路由
    REMOVE_HISTORY_MENU(state, routeId) {
      // 如果type是search，则删除id为routeId的记录
      console.log("删除历史路由",state,routeId);
      
      if(state.historyMenu.find(item => item.type === "search")){
        state.historyMenu = state.historyMenu.filter(item => item.id !== routeId);
      }else{
        state.historyMenu = state.historyMenu.filter(item => item.value.id !== routeId);
      }
    },
    
    // 更新历史路由
    UPDATE_HISTORY_MENU(state, { id, updates }) {
      const index = state.historyMenu.findIndex(item => item.value.id === id);
      if (index !== -1) {
        state.historyMenu[index] = { ...state.historyMenu[index], ...updates };
      }
    },
    
    // 清空历史路由
    CLEAR_HISTORY_MENU(state) {
      state.historyMenu = [];
    },
    
    // 设置历史路由列表
    SET_HISTORY_MENU(state, routes) {
      state.historyMenu = routes;
    },
    
    // 更新图标背景配置
    UPDATE_ICON_BACKGROUND_CONFIG(state, { key, config }) {
      state.iconBackgroundConfig[key] = config;
    }
  },
  actions: {
    // 添加历史路由
    addHistoryMenu({ commit }, route) {
      commit('ADD_HISTORY_MENU', route);
    },
    
    // 删除历史路由
    removeHistoryMenu({ commit }, routeId) {
      commit('REMOVE_HISTORY_MENU', routeId);
    },
    
    // 更新历史路由
    updateHistoryMenu({ commit }, payload) {
      commit('UPDATE_HISTORY_MENU', payload);
    },
    
    // 清空历史路由
    clearHistoryMenu({ commit }) {
      commit('CLEAR_HISTORY_MENU');
    },
    
    // 根据类型过滤路由
    getRoutesByType({ state }, type) {
      return state.historyMenu.filter(route => route.type === type);
    },
    
    // 更新图标背景配置
    updateIconBackgroundConfig({ commit }, payload) {
      commit('UPDATE_ICON_BACKGROUND_CONFIG', payload);
    }
  },
  getters: {
    // 获取所有历史路由
    getAllHistoryMenus: state => state.historyMenu,
    
    // 根据类型获取路由
    getHistoryMenusByType: state => type => {
      return state.historyMenu.filter(route => route.type === type);
    },
    
    // 获取最近的路由
    getRecentHistoryMenus: state => count => {
      return state.historyMenu.slice(0, count || 5);
    },
    
    // 根据ID获取路由
    getHistoryMenuById: state => id => {
      return state.historyMenu.find(route => route.value.id === id);
    },
    
    // 获取路由统计信息
    getHistoryMenuStats: state => {
      const stats = {};
      state.historyMenu.forEach(route => {
        stats[route.type] = (stats[route.type] || 0) + 1;
      });
      return stats;
    },
    
    // 获取图标背景配置
    getIconBackgroundConfig: state => state.iconBackgroundConfig,
    
    // 根据key获取背景样式
    getBackgroundStyleByKey: state => key => {
      const config = state.iconBackgroundConfig[key];
      if (!config) {
        return 'background: rgba(255, 255, 255, 0.2)'; // 默认背景
      }
      
      if (config.type === 'solid') {
        return `background: ${config.color}`;
      } else if (config.type === 'gradient') {
        const gradient = `linear-gradient(${config.direction}, ${config.colors.join(', ')})`;
        return `background: ${gradient}`;
      }
      
      return 'background: rgba(255, 255, 255, 0.2)';
    }
  }
});
